import { useTranslations } from 'next-intl';
import { Container, CustomImage as Image } from '..';
import styles from './UltracareInfoSection.module.css';

const cx = (...classes: (string | undefined)[]) =>
  classes.filter(Boolean).join(' ');

export const UltracareInfoSection = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  const tCommon = useTranslations('common');
  return (
    <section className={cx(styles.root, className)}>
      <Container>
        <div className={styles.content}>
          <div className={styles.imgContainer}>
            <Image
              src="web_v2/ring-buy/ultracare-ring-2.png"
              alt={tCommon('ultracareInfoSection.image.alt.ultracare')}
              width="1584"
              height={1632}
            />
          </div>
          <div className={styles.textContainer}>
            <h3>
              {/* Science-backed coaching, on us. */}
              {t('ring.ultracare.heading')}
            </h3>
            <p>
              {/* Take your health to the next level at no extra cost with our
              ACSM-certified expert performance coaches, offering
              personalized, science-backed insights into your biomarker
              trends. */}
              {t('ring.ultracare.description')}
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};
